/* PWA install + early service-worker registration.
   iPhone/iPad only allow web push from an app added to the Home Screen (iOS 16.4+);
   Android Chrome can prompt to install via `beforeinstallprompt`. */

let deferredPrompt = null;
const listeners = new Set();

export const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
export const isAndroid = () => /Android/i.test(navigator.userAgent);
export const isStandalone = () => window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;
export const canPromptInstall = () => !!deferredPrompt;

export const initPwa = () => {
  if (typeof window === 'undefined') return;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn(true));
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn(false));
  });
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    });
    // Browser rotated the push subscription — hand the fresh one to the server.
    navigator.serviceWorker.addEventListener('message', (ev) => {
      if (ev.data?.type !== 'push-resubscribed') return;
      const token = localStorage.getItem('rbr_token');
      if (!token) return;
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/push/subscribe`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ subscription: ev.data.subscription, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone }),
      }).catch(() => {});
    });
  }
};

export const onInstallAvailable = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

export const promptInstall = async () => {
  if (!deferredPrompt) return 'unavailable';
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  listeners.forEach((l) => l(false));
  return outcome; // 'accepted' | 'dismissed'
};
